import { Link } from "react-router-dom";

export type Crumb = { label: string; to?: string };

type Props = {
  items: Crumb[];
  tone?: "light" | "dark";
};

export default function Breadcrumb({ items, tone = "dark" }: Props) {
  const muted = tone === "light" ? "text-background-300" : "text-foreground-500";
  const strong = tone === "light" ? "text-background-50" : "text-foreground-900";
  const hover = tone === "light" ? "hover:text-accent-300" : "hover:text-primary-600";

  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-xs md:text-sm">
      {items.map((item, idx) => {
        const last = idx === items.length - 1;
        return (
          <span key={`${item.label}-${idx}`} className="flex items-center gap-2">
            {idx > 0 && <i className={`ri-arrow-right-s-line ${muted}`}></i>}
            {item.to && !last ? (
              <Link to={item.to} className={`${muted} ${hover} transition-colors`}>
                {item.label}
              </Link>
            ) : (
              <span className={`${strong} font-medium`}>{item.label}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
}